import { gsap, ScrollTrigger, ScrollToPlugin } from '../global/gsap';

const initJumpLinks = (section) => {
    const footer = document.querySelector('footer');
    const trigger = section.querySelector('.js-jump-links-trigger');
    const background = section.querySelector('.js-jump-links-bg');
    const jumpToSections = document.querySelectorAll('.flex-container > *[id]');

    const buttons = [...section.querySelectorAll('.js-scroll')].reverse();

    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: section,
            endTrigger: footer,
            start: 'top bottom',
            end: 'top bottom',
            onEnter: () => timeline.timeScale(1).play(),
            onEnterBack: () => timeline.timeScale(1).play(),
            onLeave: () => timeline.timeScale(2).reverse(),
            onLeaveBack: () => timeline.timeScale(2).reverse(),
        },
    });

    const mm = gsap.matchMedia();

    // Mobile
    mm.add('(max-width: 56.24em)', () => {
        gsap.set(buttons, { autoAlpha: 0, xPercent: 20 });
    });

    // Desktop
    mm.add('(min-width: 56.25em)', () => {
        gsap.set(buttons, { autoAlpha: 1, yPercent: 100 });

        timeline.to(buttons, {
            autoAlpha: 1,
            yPercent: 0,
            stagger: 0.1,
            duration: 0.6,
            ease: 'power3.inOut',
        });

        timeline.to(background, {
            width: '100%',
            duration: 1,
            ease: 'power4.inOut',
        }, '<');
    });

    const buttonTimeline = gsap.timeline({
        paused: true,
        defaults: { stagger: 0.08, duration: 0.325, ease: 'power4.inOut' },
    });

    buttonTimeline.to(buttons, { autoAlpha: 1, xPercent: 0 });

    const setActiveButton = (id) => {
        buttons.forEach((btn) => { 
            const targetId = btn.getAttribute('href')?.replace('#', '');
            btn.classList.toggle('is-active', targetId === id);
        });
    };

    jumpToSections.forEach((el) => {
        const id = el.id;

        ScrollTrigger.create({
            trigger: el,
            start: 'top 75%',
            end: 'bottom 25%',
            onEnter: () => {
                setActiveButton(id);
            },
            onEnterBack: () => setActiveButton(id),
        });
    });


    const toggleButtons = (button) => {
        const isActive = trigger.classList.toggle('is-active');
        const target = button.getAttribute('href');
        const targetEl = document.querySelector(`${target}`);
        buttonTimeline[isActive ? 'play' : 'reverse']();

        gsap.to(window, {
            duration: 0.66,
            scrollTo: {
                y: targetEl,
                offsetY: 33
            }
        });
    };

    const mobShowButtons = (trigger) => {
        const isActive = trigger.classList.toggle('is-active');
        buttonTimeline[isActive ? 'play' : 'reverse']();
    }

    trigger.addEventListener('click', () => {
        mobShowButtons(trigger);
    });

    buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            toggleButtons(button);
        });
    });
};

export default initJumpLinks;
